"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TEXT_ALIGN = void 0;

var _Builder = _interopRequireDefault(require("./Builder.js"));

var _Instruction = _interopRequireDefault(require("./Instruction.js"));

var _GeometryType = _interopRequireDefault(require("../../geom/GeometryType.js"));

var _TextPlacement = _interopRequireDefault(require("../../style/TextPlacement.js"));

var _colorlike = require("../../colorlike.js");

var _canvas = require("../canvas.js");

var _util = require("../../util.js");

var _extent = require("../../extent.js");

var _straightchunk = require("../../geom/flat/straightchunk.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/render/canvas/TextBuilder
 */


/**
 * @const
 * @enum {number}
 */
var TEXT_ALIGN = {
  'left': 0,
  'end': 0,
  'center': 0.5,
  'right': 1,
  'start': 1,
  'top': 0,
  'middle': 0.5,
  'hanging': 0.2,
  'alphabetic': 0.8,
  'ideographic': 0.8,
  'bottom': 1
};
exports.TEXT_ALIGN = TEXT_ALIGN;

var CanvasTextBuilder =
/** @class */
function (_super) {
  __extends(CanvasTextBuilder, _super);
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */


  function CanvasTextBuilder(tolerance, maxExtent, resolution, pixelRatio) {
    var _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
    /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */


    _this.labels_ = null;
    /**
     * @private
     * @type {string|Array<string>}
     */

    _this.text_ = '';
    /**
     * @private
     * @type {number}
     */

    _this.textOffsetX_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.textOffsetY_ = 0;
    /**
     * @private
     * @type {boolean|undefined}
     */

    _this.textRotateWithView_ = undefined;
    /**
     * @private
     * @type {number}
     */

    _this.textRotation_ = 0;
    /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */

    _this.textFillState_ = null;
    /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */

    _this.fillStates = {};
    /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */

    _this.textStrokeState_ = null;
    /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */

    _this.strokeStates = {};
    /**
     * @private
     * @type {import("../canvas.js").TextState}
     */

    _this.textState_ =
    /** @type {import("../canvas.js").TextState} */
    {};
    /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */

    _this.textStates = {};
    /**
     * @private
     * @type {string}
     */

    _this.textKey_ = '';
    /**
     * @private
     * @type {string}
     */

    _this.fillKey_ = '';
    /**
     * @private
     * @type {string}
     */

    _this.strokeKey_ = '';
    /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */

    _this.declutterImageWithText_ = undefined;
    return _this;
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */


  CanvasTextBuilder.prototype.finish = function () {
    var instructions = _super.prototype.finish.call(this);

    instructions.textStates = this.textStates;
    instructions.fillStates = this.fillStates;
    instructions.strokeStates = this.strokeStates;
    return instructions;
  };
  /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */


  CanvasTextBuilder.prototype.drawText = function (geometry, feature) {
    var fillState = this.textFillState_;
    var strokeState = this.textStrokeState_;
    var textState = this.textState_;

    if (this.text_ === '' || !textState || !fillState && !strokeState) {
      return;
    }

    var coordinates = this.coordinates;
    var begin = coordinates.length;
    var geometryType = geometry.getType();
    var flatCoordinates = null;
    var stride = geometry.getStride();

    if (textState.placement === _TextPlacement["default"].LINE && (geometryType == _GeometryType["default"].LINE_STRING || geometryType == _GeometryType["default"].MULTI_LINE_STRING || geometryType == _GeometryType["default"].POLYGON || geometryType == _GeometryType["default"].MULTI_POLYGON)) {
      if (!(0, _extent.intersects)(this.getBufferedMaxExtent(), geometry.getExtent())) {
        return;
      }

      var ends = void 0;
      flatCoordinates = geometry.getFlatCoordinates();

      if (geometryType == _GeometryType["default"].LINE_STRING) {
        ends = [flatCoordinates.length];
      } else if (geometryType == _GeometryType["default"].MULTI_LINE_STRING) {
        ends =
        /** @type {import("../../geom/MultiLineString.js").default} */
        geometry.getEnds();
      } else if (geometryType == _GeometryType["default"].POLYGON) {
        ends =
        /** @type {import("../../geom/Polygon.js").default} */
        geometry.getEnds().slice(0, 1);
      } else if (geometryType == _GeometryType["default"].MULTI_POLYGON) {
        var endss =
        /** @type {import("../../geom/MultiPolygon.js").default} */
        geometry.getEndss();
        ends = [];

        for (var i = 0, ii = endss.length; i < ii; ++i) {
          ends.push(endss[i][0]);
        }
      }

      this.beginGeometry(geometry, feature);
      var textAlign = textState.textAlign;
      var flatOffset = 0;
      var flatEnd = void 0;

      for (var o = 0, oo = ends.length; o < oo; ++o) {
        if (textAlign == undefined) {
          var range = (0, _straightchunk.matchingChunk)(textState.maxAngle, flatCoordinates, flatOffset, ends[o], stride);
          flatOffset = range[0];
          flatEnd = range[1];
        } else {
          flatEnd = ends[o];
        }

        for (var i = flatOffset; i < flatEnd; i += stride) {
          coordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        }

        var end = coordinates.length;
        flatOffset = ends[o];
        this.drawChars_(begin, end);
        begin = end;
      }

      this.endGeometry(feature);
    } else {
      var geometryWidths = textState.overflow ? null : [];

      switch (geometryType) {
        case _GeometryType["default"].POINT:
        case _GeometryType["default"].MULTI_POINT:
          flatCoordinates =
          /** @type {import("../../geom/MultiPoint.js").default} */
          geometry.getFlatCoordinates();
          break;

        case _GeometryType["default"].LINE_STRING:
          flatCoordinates =
          /** @type {import("../../geom/LineString.js").default} */
          geometry.getFlatMidpoint();
          break;

        case _GeometryType["default"].CIRCLE:
          flatCoordinates =
          /** @type {import("../../geom/Circle.js").default} */
          geometry.getCenter();
          break;

        case _GeometryType["default"].MULTI_LINE_STRING:
          flatCoordinates =
          /** @type {import("../../geom/MultiLineString.js").default} */
          geometry.getFlatMidpoints();
          stride = 2;
          break;

        case _GeometryType["default"].POLYGON:
          flatCoordinates =
          /** @type {import("../../geom/Polygon.js").default} */
          geometry.getFlatInteriorPoint();

          if (!textState.overflow) {
            geometryWidths.push(flatCoordinates[2] / this.resolution);
          }

          stride = 3;
          break;

        case _GeometryType["default"].MULTI_POLYGON:
          var interiorPoints =
          /** @type {import("../../geom/MultiPolygon.js").default} */
          geometry.getFlatInteriorPoints();
          flatCoordinates = [];

          for (var i = 0, ii = interiorPoints.length; i < ii; i += 3) {
            if (!textState.overflow) {
              geometryWidths.push(interiorPoints[i + 2] / this.resolution);
            }

            flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
          }

          if (flatCoordinates.length === 0) {
            return;
          }

          stride = 2;
          break;

        default:
      }

      var end = this.appendFlatPointCoordinates(flatCoordinates, stride);

      if (end === begin) {
        return;
      }

      if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
        var beg_1 = begin / 2;
        geometryWidths = geometryWidths.filter(function (w, i) {
          var keep = coordinates[(beg_1 + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg_1 + i) * 2 + 1] === flatCoordinates[i * stride + 1];

          if (!keep) {
            --beg_1;
          }

          return keep;
        });
      }

      this.saveTextStates_();

      if (textState.backgroundFill || textState.backgroundStroke) {
        this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);

        if (textState.backgroundFill) {
          this.updateFillStyle(this.state, this.createFill);
          this.hitDetectionInstructions.push(this.createFill(this.state));
        }

        if (textState.backgroundStroke) {
          this.updateStrokeStyle(this.state, this.applyStroke);
          this.hitDetectionInstructions.push(this.createStroke(this.state));
        }
      }

      this.beginGeometry(geometry, feature); // adjust padding for negative scale

      var padding = textState.padding;

      if (padding != _canvas.defaultPadding && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
        var p0 = textState.padding[0];
        var p1 = textState.padding[1];
        var p2 = textState.padding[2];
        var p3 = textState.padding[3];

        if (textState.scale[0] < 0) {
          p1 = -p1;
          p3 = -p3;
        }

        if (textState.scale[1] < 0) {
          p0 = -p0;
          p2 = -p2;
        }

        padding = [p0, p1, p2, p3];
      } // The image is unknown at this stage so we pass null; it will be computed at render time.
      // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
      // render time.


      var pixelRatio_1 = this.pixelRatio;
      this.instructions.push([_Instruction["default"].DRAW_IMAGE, begin, end, null, NaN, NaN, NaN, 1, 0, 0, this.textRotateWithView_, this.textRotation_, [1, 1], NaN, this.declutterImageWithText_, padding == _canvas.defaultPadding ? _canvas.defaultPadding : padding.map(function (p) {
        return p * pixelRatio_1;
      }), !!textState.backgroundFill, !!textState.backgroundStroke, this.text_, this.textKey_, this.strokeKey_, this.fillKey_, this.textOffsetX_, this.textOffsetY_, geometryWidths]);
      var scale = 1 / pixelRatio_1;
      this.hitDetectionInstructions.push([_Instruction["default"].DRAW_IMAGE, begin, end, null, NaN, NaN, NaN, 1, 0, 0, this.textRotateWithView_, this.textRotation_, [scale, scale], NaN, this.declutterImageWithText_, padding, !!textState.backgroundFill, !!textState.backgroundStroke, this.text_, this.textKey_, this.strokeKey_, this.fillKey_, this.textOffsetX_, this.textOffsetY_, geometryWidths]);
      this.endGeometry(feature);
    }
  };
  /**
   * @private
   */


  CanvasTextBuilder.prototype.saveTextStates_ = function () {
    var strokeState = this.textStrokeState_;
    var textState = this.textState_;
    var fillState = this.textFillState_;
    var strokeKey = this.strokeKey_;

    if (strokeState) {
      if (!(strokeKey in this.strokeStates)) {
        this.strokeStates[strokeKey] = {
          strokeStyle: strokeState.strokeStyle,
          lineCap: strokeState.lineCap,
          lineDashOffset: strokeState.lineDashOffset,
          lineWidth: strokeState.lineWidth,
          lineJoin: strokeState.lineJoin,
          miterLimit: strokeState.miterLimit,
          lineDash: strokeState.lineDash
        };
      }
    }

    var textKey = this.textKey_;

    if (!(textKey in this.textStates)) {
      this.textStates[textKey] = {
        font: textState.font,
        textAlign: textState.textAlign || _canvas.defaultTextAlign,
        textBaseline: textState.textBaseline || _canvas.defaultTextBaseline,
        scale: textState.scale
      };
    }

    var fillKey = this.fillKey_;

    if (fillState) {
      if (!(fillKey in this.fillStates)) {
        this.fillStates[fillKey] = {
          fillStyle: fillState.fillStyle
        };
      }
    }
  };
  /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */


  CanvasTextBuilder.prototype.drawChars_ = function (begin, end) {
    var strokeState = this.textStrokeState_;
    var textState = this.textState_;
    var strokeKey = this.strokeKey_;
    var textKey = this.textKey_;
    var fillKey = this.fillKey_;
    this.saveTextStates_();
    var pixelRatio = this.pixelRatio;
    var baseline = TEXT_ALIGN[textState.textBaseline];
    var offsetY = this.textOffsetY_ * pixelRatio;
    var text = this.text_;
    var strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
    this.instructions.push([_Instruction["default"].DRAW_CHARS, begin, end, baseline, textState.overflow, fillKey, textState.maxAngle, pixelRatio, offsetY, strokeKey, strokeWidth * pixelRatio, text, textKey, 1]);
    this.hitDetectionInstructions.push([_Instruction["default"].DRAW_CHARS, begin, end, baseline, textState.overflow, fillKey, textState.maxAngle, 1, offsetY, strokeKey, strokeWidth, text, textKey, 1 / pixelRatio]);
  };
  /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [opt_sharedData] Shared data.
   */


  CanvasTextBuilder.prototype.setTextStyle = function (textStyle, opt_sharedData) {
    var textState, fillState, strokeState;

    if (!textStyle) {
      this.text_ = '';
    } else {
      var textFillStyle = textStyle.getFill();

      if (!textFillStyle) {
        fillState = null;
        this.textFillState_ = fillState;
      } else {
        fillState = this.textFillState_;

        if (!fillState) {
          fillState =
          /** @type {import("../canvas.js").FillState} */
          {};
          this.textFillState_ = fillState;
        }

        fillState.fillStyle = (0, _colorlike.asColorLike)(textFillStyle.getColor() || _canvas.defaultFillStyle);
      }

      var textStrokeStyle = textStyle.getStroke();

      if (!textStrokeStyle) {
        strokeState = null;
        this.textStrokeState_ = strokeState;
      } else {
        strokeState = this.textStrokeState_;

        if (!strokeState) {
          strokeState =
          /** @type {import("../canvas.js").StrokeState} */
          {};
          this.textStrokeState_ = strokeState;
        }

        var lineDash = textStrokeStyle.getLineDash();
        var lineDashOffset = textStrokeStyle.getLineDashOffset();
        var lineWidth = textStrokeStyle.getWidth();
        var miterLimit = textStrokeStyle.getMiterLimit();
        strokeState.lineCap = textStrokeStyle.getLineCap() || _canvas.defaultLineCap;
        strokeState.lineDash = lineDash ? lineDash.slice() : _canvas.defaultLineDash;
        strokeState.lineDashOffset = lineDashOffset === undefined ? _canvas.defaultLineDashOffset : lineDashOffset;
        strokeState.lineJoin = textStrokeStyle.getLineJoin() || _canvas.defaultLineJoin;
        strokeState.lineWidth = lineWidth === undefined ? _canvas.defaultLineWidth : lineWidth;
        strokeState.miterLimit = miterLimit === undefined ? _canvas.defaultMiterLimit : miterLimit;
        strokeState.strokeStyle = (0, _colorlike.asColorLike)(textStrokeStyle.getColor() || _canvas.defaultStrokeStyle);
      }

      textState = this.textState_;

      var font = textStyle.getFont() || _canvas.defaultFont;

      (0, _canvas.registerFont)(font);
      var textScale = textStyle.getScaleArray();
      textState.overflow = textStyle.getOverflow();
      textState.font = font;
      textState.maxAngle = textStyle.getMaxAngle();
      textState.placement = textStyle.getPlacement();
      textState.textAlign = textStyle.getTextAlign();
      textState.textBaseline = textStyle.getTextBaseline() || _canvas.defaultTextBaseline;
      textState.backgroundFill = textStyle.getBackgroundFill();
      textState.backgroundStroke = textStyle.getBackgroundStroke();
      textState.padding = textStyle.getPadding() || _canvas.defaultPadding;
      textState.scale = textScale === undefined ? [1, 1] : textScale;
      var textOffsetX = textStyle.getOffsetX();
      var textOffsetY = textStyle.getOffsetY();
      var textRotateWithView = textStyle.getRotateWithView();
      var textRotation = textStyle.getRotation();
      this.text_ = textStyle.getText() || '';
      this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
      this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
      this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
      this.textRotation_ = textRotation === undefined ? 0 : textRotation;
      this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, _util.getUid)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
      this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.textBaseline || '?');
      this.fillKey_ = fillState ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, _util.getUid)(fillState.fillStyle) : '';
    }

    this.declutterImageWithText_ = opt_sharedData;
  };

  return CanvasTextBuilder;
}(_Builder["default"]);

var _default = CanvasTextBuilder;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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